import { StarIcon } from '@heroicons/react/24/outline'
import { StarIcon as FilledStarIcon } from '@heroicons/react/20/solid'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import Tooltip from '@components/shared/Tooltip'
import { TokenMinimalData } from 'types/token'
import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'

export const TOKEN_WATCHLIST_KEY = localStorageKey(
  'tokenWatchlist-0.3',
  [] as TokenMinimalData[],
)

const WatchlistButton = ({
  tokenData,
  large,
  showBackground,
}: {
  tokenData: TokenMinimalData
  large?: boolean
  showBackground?: boolean
}) => {
  const { t } = useTranslation('watchlist')
  const [watchlist, setWatchlist] = useLocalStorage(TOKEN_WATCHLIST_KEY)

  const addToFavorites = useCallback(() => {
    const newFavorites = [...watchlist, tokenData]
    setWatchlist(newFavorites)
  }, [tokenData, setWatchlist, watchlist])

  const removeFromFavorites = useCallback(() => {
    setWatchlist(
      watchlist.filter((m: TokenMinimalData) => m.mint !== tokenData.mint),
    )
  }, [tokenData, setWatchlist, watchlist])

  return watchlist.find(
    (token: TokenMinimalData) => token.mint === tokenData.mint,
  ) ? (
    <Tooltip content={t('remove-from-watchlist')}>
      <button
        className={`flex items-center justify-center text-th-active focus-visible:text-th-fgd-4 md:hover:text-th-fgd-3 ${
          showBackground
            ? `size-10 rounded-full border border-th-bkg-3 bg-th-bkg-1 shadow-[2px_2px_0_0_var(--bkg-3)]`
            : ''
        }`}
        onClick={removeFromFavorites}
      >
        <FilledStarIcon className={large ? 'size-[22px]' : 'size-[18px]'} />
      </button>
    </Tooltip>
  ) : (
    <Tooltip content={t('add-to-watchlist')}>
      <button
        className={`flex items-center justify-center text-th-fgd-2 focus-visible:text-th-active md:hover:text-th-active ${
          showBackground
            ? `size-10 rounded-full border border-th-bkg-3 bg-th-bkg-1 shadow-[2px_2px_0_0_var(--bkg-3)]`
            : ''
        }`}
        onClick={addToFavorites}
      >
        <StarIcon className={large ? 'size-[22px]' : 'size-[18px]'} />
      </button>
    </Tooltip>
  )
}

export default WatchlistButton
